
export const SET_CURRENT_CUSTOMER = (state, val) => {
  state.currentCustomer = val;
}

export const SET_CURRENT_CUSTOMER_ROLE = (state, val) => {
  state.currentCustomer.role = val;
}

export const SAVE_CUSTOMERS_LIST = (state, val) => {
  state.customersList = val;
}

export const SAVE_MORE_CUSTOMERS = (state, val) => {
  state.customersList = [...state.customersList, ...val];
}

export const SAVE_CUSTOMERS_TOTAL = (state, val) => {
  state.customersTotal = val;
}

export const SAVE_CURRENT_CUSTOMER_DOCUMENT = (state, val) => {
  let documents = [...state.currentCustomer.documents]
  let index = documents.findIndex(item => item.document_type_id == val.document_type_id);

  documents[index] = val;
  state.currentCustomer.documents = documents;
}

export const SET_CURRENT_CUSTOMER_COUPON = (state, val) => {
  state.currentCustomer.coupon_id = val.coupon_id;
  state.currentCustomer.coupon_code = val.coupon_code;
}

export const SET_CURRENT_CUSTOMER_TRIAL = (state, val) => {
  state.currentCustomer.trial_end_date = val;
}